import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Icon, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from "@mui/material";
import TablePagination from '@mui/material/TablePagination';
import TableFooter from '@mui/material/TableFooter';
import { useLocation, useNavigate } from "react-router-dom";
import { useGetByCatIdQuery, useDeleteSubCategoryMutation, useReorderSubCategoriesMutation } from "App/services/subCategoryServiceApi";
import TablePaginationActions from "@mui/material/TablePagination/TablePaginationActions";
import EditSubCategoryFormDialogue from "./components/EditSubCategoryFormDialogue";
import SubCategoryFormDialogue from "./components/SubCategoryFormDialogue";
import Loading from "components/Loading";
import useReorder from "components/Reorder/useReorder";
import useFeatureEnabled from "components/FeatureToggle/useFeatureEnabled";
import ReorderableTableRow, { DragColumnHeader } from "components/Reorder/ReorderableTableRow";

const useAllData = (data) => {
  // const allSubCategoryQuery = useGetAllSubCategoryQuery({ refetchOnFocus: false });
  const byCatIdQuery = useGetByCatIdQuery(data, { refetchOnFocus: false });

  const [result, setResult] = useState({
    data: null,
    isLoading: true,
    isError: false,
    error: null,
    refetch: () => {},
  });

  useEffect(() => {
    if (data !== null) {
      setResult({
        data: byCatIdQuery.data,
        isLoading: byCatIdQuery.isLoading,
        isError: byCatIdQuery.isError,
        error: byCatIdQuery.error,
        refetch: byCatIdQuery.refetch,
      });
    }
  }, [data, byCatIdQuery]);

  return result;
};

function SubCategory() {
  const [open, setOpen] = React.useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const dragDropEnabled = useFeatureEnabled("drag_drop_reorder");
  const navigate = useNavigate();



  const location = useLocation();
  const data = location.state || {};

  const { data: subCategories, isLoading, isFetching, isError, error, refetch } = useAllData(data.data);
  const [deleteSubCategory] = useDeleteSubCategoryMutation();
  const [reorderSubCategories] = useReorderSubCategoriesMutation();

  const { ordered: sortedSubCategories, handleDragStart, handleDragOver, handleDrop } = useReorder(
    subCategories,
    (ids) => reorderSubCategories({ categoryId: data.data, orderedIds: ids }).catch((err) => console.log(err))
  );

  if (isLoading || isFetching) {
    return <Loading />;
  }

  // Delete Botton and Delete Dialog Box work

  const handleDeleteSubcategory = async () => {

    try {

      await deleteSubCategory(deleteId).unwrap();
      setDeleteDialogOpen(false);
      setDeleteId(null);
      if (subCategories.length === 1) {
        window.location.reload(); 
      } else {
        refetch();
      }
    } catch (error) {

      console.error("Failed to delete subcategory:", error);
    }
  };

  const handleDeleteConfirmation = (subCategoriesId) => {
    setDeleteId(subCategoriesId);
    setDeleteDialogOpen(true);
  };



  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setDeleteId(null);
  };


  // Subcategory Id navigate to Chapter

  const handleNavigateChapter = async (subcategoryId, categoryId) => {


    navigate('/chapter', { state: { data: subcategoryId, categoryId } });
  }

  // Pagination System

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (subCategories ?

    // check category under any subcategory show
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <MDTypography variant="h6" color="white">
                  Sub Category
                </MDTypography>
                <SubCategoryFormDialogue />
              </MDBox>
              <TableContainer >
                <Table>
                  <TableHead  >
                    <TableRow>
                      <DragColumnHeader enabled={dragDropEnabled} />
                      <TableCell>Name</TableCell>
                      <TableCell sx={{ textAlign: 'right', paddingRight: 20 }}>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(rowsPerPage > 0
                      ? sortedSubCategories && sortedSubCategories.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      : sortedSubCategories
                    ).map((subcategory) => (

                      <ReorderableTableRow
                        key={subcategory.id}
                        id={subcategory.id}
                        dragEnabled={dragDropEnabled}
                        onDragStart={handleDragStart}
                        onDragOver={handleDragOver}
                        onDrop={handleDrop}
                        sx={{ '&:hover': { backgroundColor: '#f5f5f5' } }}
                      >
                        {/* {console.log(subcategory)} */}
                        <TableCell sx={{ textAlign: 'left', textDecorationLine: 'underline', cursor: 'pointer', '&:hover': { color: 'blue' } }} onClick={() => handleNavigateChapter(subcategory.id, subcategory.cat_id)}>{subcategory.name}</TableCell>
                        <TableCell sx={{ textAlign: 'right', paddingRight: 17 }}>
                          <Tooltip title="Edit">
                            <span>
                              <EditSubCategoryFormDialogue subcategory={subcategory} />
                            </span>
                          </Tooltip>
                          <Tooltip title="Delete">
                            <IconButton aria-label="delete"
                              onClick={() => handleDeleteConfirmation(subcategory.id)}
                            >
                              <Icon>delete</Icon>

                              {/* <Delete subcategory={subcategory.id}/> */}
                            </IconButton>

                          </Tooltip>
                        </TableCell>
                      </ReorderableTableRow>
                    ))}
                  </TableBody>


                  {/* pagination */}


                  <TableFooter>

                    <TableRow >
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                        colSpan={dragDropEnabled ? 3 : 2}
                        count={sortedSubCategories.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        SelectProps={{
                          inputProps: {
                            'aria-label': 'rows per page',
                          },
                          native: true,
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      // ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {/* <Footer /> */}


      {/* Delete Dialog Box Open */}

      <Dialog
        open={deleteDialogOpen}
        onClose={handleCloseDeleteDialog}
        sx={{ textAlign: 'center' }}
      >
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this subcategory and all its associated chapters and questions?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteSubcategory} style={{ color: 'red' }}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
    :

    // not Available any subcategory show only Head components 

    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <MDTypography variant="h6" color="white">
                  Sub Category
                </MDTypography>
                <SubCategoryFormDialogue />
              </MDBox>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell sx={{ textAlign: "left" }}>Action</TableCell>
                    </TableRow>
                  </TableHead>
                </Table>
              </TableContainer>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default SubCategory;
